<div id="related-yx-services-section">
    <h1>{{ 'dashboard.relatedServices.title' | translate }}</h1>

    <div class="services-container">
        <div id="automatic-genotyping-details" class="service-card">
            <a
                [href]="environment.automatedGenotypingUrl"
                target="_blank"
                [attr.aria-label]="'dashboard.relatedServices.automaticGenotyping.ariaLabel' | translate"
                (click)="logEvent('automatic-genotyping')">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
            <p class="service-name">{{ 'dashboard.relatedServices.automaticGenotyping.title' | translate }}</p>
            <p class="service-description">
                {{ 'dashboard.relatedServices.automaticGenotyping.description' | translate }}
            </p>
        </div>

        <div id="genetic-monitoring-details" class="service-card">
            <a
                [href]="environment.geneticMonitoringUrl"
                target="_blank"
                [attr.aria-label]="'dashboard.relatedServices.geneticMonitoring.ariaLabel' | translate"
                (click)="logEvent('genetic-monitoring')">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
            <p class="service-name">{{ 'dashboard.relatedServices.geneticMonitoring.title' | translate }}</p>
            <p class="service-description">
                {{ 'dashboard.relatedServices.geneticMonitoring.description' | translate }}
            </p>
        </div>

        <div id="microbiome-details" class="service-card">
            <a
                [href]="environment.microbiomeUrl"
                target="_blank"
                [attr.aria-label]="'dashboard.relatedServices.microbiome.ariaLabel' | translate"
                (click)="logEvent('microbiome')">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
            <p class="service-name">{{ 'dashboard.relatedServices.microbiome.title' | translate }}</p>
            <p class="service-description">{{ 'dashboard.relatedServices.microbiome.description' | translate }}</p>
        </div>

        <div id="checkmate-details" class="service-card">
            <a
                [routerLink]="ckmUrl()"
                target="_blank"
                [attr.aria-label]="'dashboard.relatedServices.checkMate.ariaLabel' | translate"
                (click)="logEvent('checkmate')">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
            <p class="service-name">{{ 'dashboard.relatedServices.checkMate.title' | translate }}</p>
            <p class="service-description">{{ 'dashboard.relatedServices.checkMate.description' | translate }}</p>
        </div>
    </div>
</div>
